<template>
  <v-row
    no-gutters
  >
    <v-col>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
            'items-per-page-options': [15,30,60,100,150,250],
          }"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            x-small
            class="mr-2"
            color="primary"
            @click="process(item)"
          >
            View
          </v-btn>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.transferred_at"
            :label="true"
            x-small
            color="success"
            >Withdrawn
          </v-chip>
          <v-chip
            v-else
            :label="true"
            x-small
            color="warning"
          >Waiting
          </v-chip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      options: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'email' },
        { text: 'First Name', value: 'first_name' },
        { text: 'Last Name', value: 'last_name' },
        { text: 'Bank', value: 'bank' },
        { text: 'Account Name', value: 'account_name' },
        { text: 'Account No. / PayNow', value: 'account_no' },
        { text: 'Commissions', value: 'amount' },
        { text: 'Payment Reference', value: 'reference_no' },
        { text: 'Payment Date', value: 'transferred_at' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.loadTable();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    loadTable() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.loading = true;
      this.$api.post('admin/commission/withdraw/list', {
        search: {
          '*': this.search,
        },
        current_page: page,
        per_page: itemsPerPage,
        order: `${sortBy}:${sortDesc}`,
      }).then((response) => {
        this.totalItems = response.data.total;
        this.items = response.data.data;
        this.loading = false;
      });
    },
    process(item) {
      this.$router.push({ name: 'Admin.PartnerCommissionWithdrawDetail', params: { id: item.id } });
    },
  },
};
</script>

<style scoped>

</style>
